function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import AssertionFailedException from './AssertionFailedException';
var Assert = /*#__PURE__*/function () {
  function Assert() {
    _classCallCheck(this, Assert);
    Assert.constructor_.apply(this, arguments);
  }
  return _createClass(Assert, [{
    key: "getClass",
    value: function getClass() {
      return Assert;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "shouldNeverReachHere",
    value: function shouldNeverReachHere() {
      if (arguments.length === 0) {
        Assert.shouldNeverReachHere(null);
      } else if (arguments.length === 1) {
        var message = arguments[0];
        throw new AssertionFailedException('Should never reach here' + (message !== null ? ': ' + message : ''));
      }
    }
  }, {
    key: "isTrue",
    value: function isTrue() {
      if (arguments.length === 1) {
        var assertion = arguments[0];
        Assert.isTrue(assertion, null);
      } else if (arguments.length === 2) {
        var _assertion = arguments[0];
        var message = arguments[1];
        if (!_assertion) {
          if (message === null) {
            throw new AssertionFailedException();
          } else {
            throw new AssertionFailedException(message);
          }
        }
      }
    }
  }, {
    key: "equals",
    value: function equals() {
      if (arguments.length === 2) {
        var expectedValue = arguments[0];
        var actualValue = arguments[1];
        Assert.equals(expectedValue, actualValue, null);
      } else if (arguments.length === 3) {
        var _expectedValue = arguments[0];
        var _actualValue = arguments[1];
        var message = arguments[2];
        if (!_actualValue.equals(_expectedValue)) {
          throw new AssertionFailedException('Expected ' + _expectedValue + ' but encountered ' + _actualValue + (message !== null ? ': ' + message : ''));
        }
      }
    }
  }]);
}();
export { Assert as default };
Assert.constructor_ = function () {};